import React from "react";
import { Modal, Title, Group, Button } from "@mantine/core";
import classes from "./delete.module.css";

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose} withCloseButton={false}>
      <Title className={classes.title} order={4}>
        Are you sure you want to delete this item?
      </Title>
      <Group className={classes.buttonPart}>
        <Button onClick={onClose} className={classes.buttonCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm} className={classes.buttonDelete}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteModal;
